<template>
  <div class="cmr-button-type2" @click="$router.push(path)">
    {{ text }}
    <div class="icon">
      <svg-icon iconClass="solutions-right-arrow"></svg-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      default: "Learn More",
      type: String,
    },
    path: {
      default: {},
      type: Object,
    },
  },
};
</script>

<style lang="less" scoped>
.cmr-button-type2 {
  display: flex;
  width: 2rem;
  align-items: center;
  justify-content: center;
  line-height: 0.6rem;
  background-color: #b94060;
  color: white;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
  .icon {
    margin-left: 0.1rem;
    margin-top: 0.07rem;
    font-size: 0.18rem;
  }
}
@media screen and(max-width:760px) {
  .cmr-button-type2{
    width: 2.8rem;
    line-height: 0.85rem;
    
    .icon{
      font-size: 0.25rem;
      margin-left: 0.15rem;
    }
  }
}
</style>
